var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { useCombinedRef } from "../../hooks/useCombinedRef";
import { useGotFocusTroughTabbing } from "./hooks/useGotFocusTroughTabbing";
import { useKeyboardControl } from "./hooks/useKeyboardControl";
import { useAutofocus } from "./hooks/useAutofocus";
const Wrapper = forwardRef(function Wrapper(_a, forwardedRef) {
    var { enableKeyboardControl = false, feature, className = "" } = _a, attrs = __rest(_a, ["enableKeyboardControl", "feature", "className"]);
    const ownRef = useRef(null);
    // TODO: Focus management
    //  [x] Focus should not be trapped inside the component.
    //  [x] The FSI is not modal.
    //  [x] Clicks and tabbing outside should be allowed.
    //  [x] When the focus is not inside the component,
    //     pressing escape should do nothing.
    //  [*] When getting focus from a keyboard interaction (not tabbing in),
    //     pressing escape should close the component and focus should be
    //     returned to the previously focused element.
    //      * NOTE: Right now it will be returned to the list always!
    //  [ ] When getting focus by tabbing into the component,
    //     pressing escape should close the component and focus should be
    //     returned to the closest tabbable element (maybe main container?).
    const [gotFocusThroughTabbing, setGotFocusThroughTabbing] = useGotFocusTroughTabbing(ownRef);
    useAutofocus(enableKeyboardControl, ownRef, feature, () => {
        setGotFocusThroughTabbing(false);
    });
    useKeyboardControl(enableKeyboardControl, ownRef, feature, {
        returnFocusToList: !gotFocusThroughTabbing,
    });
    return (_jsx("div", Object.assign({ ref: useCombinedRef(ownRef, forwardedRef), className: `ms3-feature-selection-info__wrapper ms3-scroll-target ${className}`, tabIndex: enableKeyboardControl ? -1 : undefined }, attrs)));
});
export default Wrapper;
